import { render, staticRenderFns } from "./InventoryOrderEmployeeSalary.vue?vue&type=template&id=0024b9a2&scoped=true"
import script from "./InventoryOrderEmployeeSalary.vue?vue&type=script&lang=js"
export * from "./InventoryOrderEmployeeSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024b9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0024b9a2')) {
      api.createRecord('0024b9a2', component.options)
    } else {
      api.reload('0024b9a2', component.options)
    }
    module.hot.accept("./InventoryOrderEmployeeSalary.vue?vue&type=template&id=0024b9a2&scoped=true", function () {
      api.rerender('0024b9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/employeeSalaryTableExcelDialog/InventoryOrderEmployeeSalary.vue"
export default component.exports